import { Flex } from '@chakra-ui/react';
import Card from 'components/card/Card';
import FormCadastrarEditarRecurso from 'components/forms/capacity/resources/FormCadastrarEditarRecurso';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

import { LoadingSpinner } from '../../../../components/loading/Loading';
import { numberToLocaleString } from '../../../../utils/functions/number';
import { useAvailabilityMinutes } from './hooks/useAvailabilityMinutes';
import { useBrandList } from './hooks/useBrandList';
import { useGetResourceWithId } from './hooks/useGetResourceWithId';
import { useModelList } from './hooks/useModelList';
import { useVersionList } from './hooks/useVersionList';

export default function EditarRecurso() {
	const { id: resourceId } = useParams<any>();

	const [formInitialState, setFormInitialState] = useState<any>();
	const [autocompleteAdditionalData, setAutocompleteAditionalData] =
		useState<any>();

	const { setters } = useContext(SidebarHelpContext);

	const { setDataSidebar } = setters;

	const helpRecursos: ISidebarHelp = useMemo(
		() => ({
			title: 'Editar Recursos',
			firstParagraph:
				'Para editar um recurso informe o nome do Recurso, Grupo do Recurso (possível cadastrar novo grupo no botão “Adicionar”), Marca, Modelo e Versão. Informe também se este recurso é Gargalo (recursos mais lentos) e seu IROG.',
			firstLink: URL_CT360,
			secondLink: URL_FALE_CONOSCO,
		}),
		[]
	);

	const { data: resourceData, isLoading: isLoadingResource } =
		useGetResourceWithId(resourceId);
	const { data: BrandData, isLoading: isLoadingBrandData } = useBrandList();
	const { data: ModelData, isLoading: isLoadingModelData } = useModelList();
	const { data: VersionData, isLoading: isLoadingVersionData } =
		useVersionList();
	const {
		data: AvailabilityMinutesData,
		isLoading: isLoadingAvailabilityMinutesData,
	} = useAvailabilityMinutes();

	useEffect(() => {
		setDataSidebar(helpRecursos);
	}, [helpRecursos, setDataSidebar]);

	useEffect(() => {
		if (resourceData) {
			setFormInitialState({
				id: resourceData?.id,
				maquina: String(resourceData?.maquina),
				descricao: resourceData?.descricao,
				grupo_recurso_id: resourceData?.grupo_recurso_id,
				disponibilidade_minutos_dia:
					resourceData?.disponibilidade_minutos_dia,
				nome_marca: resourceData['versao.modelo.marca.nome_marca'],
				nome_modelo: resourceData['versao.modelo.nome_modelo'],
				nome_versao: resourceData['versao.nome_versao'],
				gargalo: String(resourceData?.gargalo),
				tipo_dados_irog: 'MANUAL',
				disponibilidade_irog: numberToLocaleString({
					value: resourceData?.disponibilidade_irog,
					maximumFractionDigits: 2,
				}),
				desempenho_irog: numberToLocaleString({
					value: resourceData?.desempenho_irog,
					maximumFractionDigits: 2,
				}),
				qualidade_irog: numberToLocaleString({
					value: resourceData?.qualidade_irog,
					maximumFractionDigits: 2,
				}),
				irog: numberToLocaleString({
					value: resourceData?.irog,
					maximumFractionDigits: 2,
				}),
			});

			setAutocompleteAditionalData({
				resourceGroup: {
					grupo_recurso_id: resourceData['grupo_recurso.id'],
					nome_grupo_recurso:
						resourceData['grupo_recurso.nome_grupo_recurso'],
				},
				brandes: BrandData,
				models: ModelData,
				versions: VersionData,
				availableMinutes: AvailabilityMinutesData,
			});
		}
	}, [
		AvailabilityMinutesData,
		BrandData,
		ModelData,
		VersionData,
		resourceData,
	]);

	return isLoadingResource ||
		isLoadingAvailabilityMinutesData ||
		isLoadingBrandData ||
		isLoadingModelData ||
		isLoadingVersionData ||
		!formInitialState ? (
		<LoadingSpinner />
	) : (
		<Flex
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<Card px='0px'>
				<FormCadastrarEditarRecurso
					initialState={formInitialState}
					resourceId={resourceId}
					autocompleteAdditionalData={autocompleteAdditionalData}
				/>
			</Card>
		</Flex>
	);
}
